// eslint-disable-next-line no-use-before-define
import React from 'react';
import { Container } from './style';
const Tag = ({ text, type = 'default', icon }) => {
    const hasIcon = icon ? ' has-icon-left' : '';
    return React.createElement(Container, { className: `tag ${type}${hasIcon}` },
        icon,
        " ",
        text);
};
export { Tag };
//# sourceMappingURL=index.js.map